import { DataService } from "./dataService";

export const ServiceEnquiry = {
  cargoEnquiry: async (data) => {
    return DataService.post("/user/shipping_enquiry_mail", data);
  },
  packingEnquiry: async (data) => {
    return DataService.post("/user/packaging_enquiry_mail", data);
  },
  transitInsuranceEnquiry: async (data) => {
    return DataService.post("/user/transit_insurance_mail", data);
  },
  consolidatedEnquiry: async (data) => {
    return DataService.post("/user/relocation_mail", data);
  },
  relocationEnquiry: async (data) => {
    return DataService.post("/user/relocation_enquiry_mail", data);
  },
};

export default ServiceEnquiry;
